import React, { useState, useEffect } from "react";
import { API } from "../lib/api";

// Small cached instrument logo with a letter-avatar fallback.
//
// `logo` only says that a logo exists. The image itself always comes from our own
// /api/logo/{ticker} (backend/routes_logo.py), never from the third-party URL in
// it: loading that directly would send the member's IP address, and the list of
// instruments they look at, to the icon service.
export default function InstrumentLogo({ logo, ticker = "", size = 40, rounded = "rounded-lg", className = "" }) {
  const [err, setErr] = useState(false);
  useEffect(() => setErr(false), [logo, ticker]);
  const style = { width: size, height: size };
  if (logo && ticker && !err) {
    return (
      <img src={`${API}/logo/${encodeURIComponent(ticker)}`} onError={() => setErr(true)} alt="" style={style}
        className={`${rounded} object-contain bg-white border border-slate-100 p-0.5 shrink-0 ${className}`} />
    );
  }
  return (
    <div style={style} className={`${rounded} bg-brand-50 text-brand-600 flex items-center justify-center font-semibold shrink-0 ${className}`}>
      {(ticker || "?").slice(0, 3).toUpperCase()}
    </div>
  );
}
